<template>
	<div id="ct-footer">
        <div class="ct-sur-footer">
            <div class="ct-sur-footer-taille ct-resolution-width ct-secondary-color">
				<div class="ct-sur-footer-bloc">
					<div>
					<h3><span>Plan du site</span></h3>
					</div>

					<div>
					<router-link class="ct-sur-footer-menu-item" to="/entreprise"
					:class="{'ct-sur-footer-menu-selected-line': isCurrentPath('/entreprise')}">
					<i class="material-icons -icone">home</i>
					</router-link>

					<router-link class="ct-sur-footer-menu-item" to="/realisations"
					:class="{'ct-sur-footer-menu-selected-line': isCurrentPath('/realisations')}">
					<i class="material-icons -icone">extension</i>
					</router-link>

					<router-link class="ct-sur-footer-menu-item" to="/contact"
					:class="{'ct-sur-footer-menu-selected-line': isCurrentPath('/contact')}">
					<i class="material-icons -icone">email</i>
					</router-link>
					</div>
				</div>
				<hr>
				<div class="ct-sur-footer-bloc">
						<h3><span>Contactez-nous</span></h3>
						<span>(+33) 6 23 72 58 19</span>
						<span>contact@creatison.fr</span>
						<span>
                        <a href="https://www.facebook.com/Creatison/" target="blank" class="ct-sur-footer-contact-facebook">
                            <i class="fab fa-facebook-f"></i>acebook
                        </a>
                    </span>
				</div>
				<hr>

				<div class="ct-sur-footer-bloc">
					<div>
						<h3><span>Partagez-nous</span></h3>
					</div>

					<div class="ct-sur-footer-partage-icone">
						<a :href="'http://www.facebook.com/share.php?u=' + getUrl()" target="blank">
							<i class="fab fa-facebook-square ct-sur-footer-partage-facebook-img"></i>
						</a>
						<a :href="'http://twitter.com/intent/tweet?status=' + getUrl()" target="blank">
							<i class="fab fa-twitter-square ct-sur-footer-partage-twitter-img"></i>
						</a>
						<a :href="'https://plus.google.com/share?url=' + getUrl()" target="blank">
							<i class="fab fa-google-plus-square ct-sur-footer-partage-google-img"></i>
						</a>
						<a :href="'http://www.linkedin.com/shareArticle?mini=true&url=' + getUrl()" target="blank">
							<i class="fab fa-linkedin ct-sur-footer-partage-linkedin-img"></i>
						</a>
					</div>
				</div>
            </div>
        </div>

        <div class="ct-sous-footer">
            <div class="ct-sous-footer-taille ct-resolution-width">
                <div class="">
                    <span onclick="javascript:window.open('mentions-legales.html', '', config='height=600, width=500, toolbar=no, menubar=no, scrollbars=yes, resizable=no, location=no, directories=no, status=no');" rel="nofollow" class="ct-sous-footer-mentions-legales ct-clean-color">Mentions légales</span>
                </div>

                <div class="ct-sous-footer-copyright">
                    <span class="ct-primary-color">{{ copyright }} <i class="far fa-copyright"></i></span>
                    <span class="ct-primary-color">&nbsp;&nbsp;<span class="ct-policy-enter ct-clean-color">CREA<span class="ct-primary-color">T</span>ISON</span></span>
                </div>
            </div>
        </div>
	</div>
</template>

<script>
	export default {
		name: 'CtFooter',
		data() {
			return {
                copyright: 'copyright 2018'
			}
		},
		methods: {
			isCurrentPath(to) {
				return this.$route.path.match(new RegExp("^"+to));
            },
            getUrl() {
                return 'http://www.creatison.fr' + this.$route.fullPath;
            }
		}
	}
</script>

<style scoped>
	#ct-footer {
		display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
	}

	.ct-sur-footer {
		display: flex;
		justify-content: center;
		background-color: #EDEDEE;
        width: 100%;
	}

	.ct-sur-footer-bloc {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.ct-sur-footer-taille {
		display: flex;
		justify-content: space-between;
		padding: 20px;
	}

	.ct-sur-footer-taille hr {
		height: 100%;
	}

	.ct-sous-footer {
		display: flex;
		justify-content: center;
		background-color: #4A4A4A;
        width: 100%;
	}

	.ct-sous-footer-taille {
		display: flex;
		justify-content: space-between;
		padding: 20px;
	}

    .ct-sous-footer-mentions-legales {
        cursor: pointer;
		-webkit-transition: color .3s;
    }

    .ct-sous-footer-mentions-legales:hover {
		color: #B0E900;
    }

	.ct-sur-footer-menu-item {
		cursor: pointer;
		color: #4A4A4A;
		padding-right: 10px;
		transition: color .3s;
		-webkit-transition: color .3s;
	}

	.ct-sur-footer-menu-item:hover {
		color: #B0E900;
	}

	.ct-sur-footer-menu-selected-line {
		color: #B0E900;
	}

    .ct-sur-footer-contact {
        border-right: 1px #4A4A4A solid;
        border-left: 1px #4A4A4A solid;
    }

    .ct-sur-footer-contact-facebook {
        cursor: pointer;
		color: #5167AE;
		padding-right: 10px;
		transition: color .3s;
		-webkit-transition: color .3s;
    }

	.ct-sur-footer-contact-facebook:hover {
		color: #C0E836;
	}

    .ct-sur-footer-partage-facebook-img {
        cursor: pointer;
		color: #5167AE;
		padding-right: 10px;
		transition: color .3s;
		-webkit-transition: color .3s;
        font-size: 24px;
    }

	.ct-sur-footer-partage-facebook-img:hover {
		color: #C0E836;
	}

    .ct-sur-footer-partage-twitter-img {
        cursor: pointer;
		color: #5F9EEF;
		padding-right: 10px;
		transition: color .3s;
		-webkit-transition: color .3s;
        font-size: 24px;
    }

	.ct-sur-footer-partage-twitter-img:hover {
		color: #C0E836;
	}

    .ct-sur-footer-partage-google-img {
        cursor: pointer;
		color: #C0533D;
		padding-right: 10px;
		transition: color .3s;
		-webkit-transition: color .3s;
        font-size: 24px;
    }

	.ct-sur-footer-partage-google-img:hover {
		color: #C0E836;
	}

    .ct-sur-footer-partage-linkedin-img {
        cursor: pointer;
		color: #4475B1;
		padding-right: 10px;
		transition: color .3s;
		-webkit-transition: color .3s;
        font-size: 24px;
    }

	.ct-sur-footer-partage-linkedin-img:hover {
		color: #C0E836;
	}

	.ct-sous-footer-copyright {
		display: flex;
		align-items: center;
	}

	/*!*smartphone*!*/
	@media screen and (max-width: 767px ) {
		.ct-sur-footer-taille {
			flex-direction: column;
			align-items: center;
		}
		.ct-sur-footer-bloc {
			margin-bottom: 20px;
		}
		.ct-sur-footer-taille hr {
			width: 100%;
			height: auto;
		}
		.ct-sur-footer-contact-facebook,
		.ct-sur-footer-partage-facebook-img
		{
			color: #5167AE;
		}

		.ct-sur-footer-partage-google-img {
			color: #C0533D;
		}

		.ct-sur-footer-partage-linkedin-img {
			color: #4475B1;
		}

		.ct-sur-footer-partage-twitter-img {
			color: #5F9EEF;
		}

		.ct-sous-footer-copyright {
			flex-direction: column;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/CtFooter.vue